export const STORAGE_KEYS = {
  TOKEN: 'store_token',
  REFRESH_TOKEN: 'store_refresh_token',
  CUSTOMER_ID: 'store_customer_id',
  EMAIL: 'store_email',
  DISPLAY_NAME: 'store_display_name',
  COLOR_MODE: 'store_color_mode',
  CURRENCY: 'store_currency',
  LOCALE: 'store_locale',
  ADMIN_TOKEN: 'store_admin_token',
  ADMIN_DISPLAY_NAME: 'store_admin_display_name',
  ADMIN_COOKIE_SESSION: 'store_admin_cookie_session',
  ADMIN_CSRF: 'store_admin_csrf',
  CUSTOMER_COOKIE_SESSION: 'store_customer_cookie_session',
  CUSTOMER_CSRF: 'store_customer_csrf',
  COOKIES_ACCEPTED: 'store_cookies_accepted',
  THEME: 'store_theme',
} as const;
